<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
           <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <listContent></listContent>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsNewsBlockControl from '../components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
import listContent from '../components/listContent'
export default {
  data() {
    return {
      title: '',
      ColumnId: 0,
    }
  },
  components: {
    DocumentsNewsBlockControl,
    listContent,
  },
}
</script>

<style scoped></style>
